var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMadayn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 44C38 42.8954 38.8954 42 40 42H78C79.1046 42 80 42.8954 80 44V78C80 79.1046 79.1046 80 78 80H40C38.8954 80 38 79.1046 38 78V44ZM42 46V76H76V46H42Z",
    fill: "#E59E6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2C0 0.89543 0.89543 0 2 0H21C21.5482 0 22.0724 0.22504 22.45 0.622501L41.45 20.6225C41.8031 20.9942 42 21.4873 42 22V78C42 79.1046 41.1046 80 40 80H2C0.89543 80 0 79.1046 0 78V2ZM4 4V76H38V22.7986L20.1414 4H4Z",
    fill: "#E59E6D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.5858 24.5858C59.3668 23.8047 60.6332 23.8047 61.4142 24.5858L79.4142 42.5858C80.1953 43.3668 80.1953 44.6332 79.4142 45.4142C78.6332 46.1953 77.3668 46.1953 76.5858 45.4142L58.5858 27.4142C57.8047 26.6332 57.8047 25.3668 58.5858 24.5858Z",
    fill: "#E59E6D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.4866 24.6621C60.7477 23.8411 59.4831 23.7745 58.6621 24.5134L38.6621 42.5134C37.841 43.2523 37.7745 44.5169 38.5134 45.3379C39.2523 46.159 40.5169 46.2255 41.3379 45.4866L61.3379 27.4866C62.1589 26.7477 62.2255 25.4831 61.4866 24.6621Z",
    fill: "#E59E6D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 56C53.1046 56 54 56.8954 54 58L54 76C54 77.1046 53.1046 78 52 78C50.8954 78 50 77.1046 50 76L50 58C50 56.8954 50.8954 56 52 56Z",
    fill: "#E59E6D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 22L22 22C23.1046 22 24 22.8954 24 24C24 25.1046 23.1046 26 22 26L10 26C8.89543 26 8 25.1046 8 24C8 22.8954 8.89543 22 10 22Z",
    fill: "#E59E6D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 22L32 22C33.1046 22 34 22.8954 34 24C34 25.1046 33.1046 26 32 26L28 26C26.8954 26 26 25.1046 26 24C26 22.8954 26.8954 22 28 22Z",
    fill: "#E59E6D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 34C34 35.1046 33.1046 36 32 36L10 36C8.89543 36 8 35.1046 8 34C8 32.8954 8.89543 32 10 32L32 32C33.1046 32 34 32.8954 34 34Z",
    fill: "#E59E6D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 44C34 45.1046 33.1046 46 32 46L10 46C8.89543 46 8 45.1046 8 44C8 42.8954 8.89543 42 10 42L32 42C33.1046 42 34 42.8954 34 44Z",
    fill: "#E59E6D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 54C34 55.1046 33.1046 56 32 56L10 56C8.89543 56 8 55.1046 8 54C8 52.8954 8.89543 52 10 52L32 52C33.1046 52 34 52.8954 34 54Z",
    fill: "#E59E6D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66 56C67.1046 56 68 56.8954 68 58L68 76C68 77.1046 67.1046 78 66 78C64.8954 78 64 77.1046 64 76L64 58C64 56.8954 64.8954 56 66 56Z",
    fill: "#E59E6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMadayn);
export default __webpack_public_path__ + "static/media/madayn.5f2b22ec19ee9716c0c7272f018d1009.svg";
export { ForwardRef as ReactComponent };